import { render, staticRenderFns } from "./AddMetric.vue?vue&type=template&id=25c04822&scoped=true"
import script from "./AddMetric.vue?vue&type=script&lang=js"
export * from "./AddMetric.vue?vue&type=script&lang=js"
import style0 from "./AddMetric.vue?vue&type=style&index=0&id=25c04822&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25c04822",
  null
  
)

export default component.exports